export const tabsName = ['Zakázka', 'auta', 'pracovníci'];
